import React from 'react';
import PropTypes from 'prop-types';

import { Span } from '@sopranodesign/pulse-components';

const LocationScope = ({ content }) => {
  return <Span>{content.name}</Span>;
};

LocationScope.propTypes = {
  content: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired
};

export default LocationScope;
